import * as AlarmThresholdActions from '../actions/alarm-threshold.actions';
import { Threshold } from '@dch/products-business-logic';

export interface AlarmThresholdState {
  removed: boolean;
  added: boolean;
  closed: boolean;
  updated: boolean;
  newThreshold: Threshold;
}

export const initialState: AlarmThresholdState = {
  removed: undefined,
  added: undefined,
  closed: undefined,
  updated: undefined,
  newThreshold: undefined,
};

export function reducer(
  state: AlarmThresholdState = initialState,
  action: AlarmThresholdActions.Actions,
): AlarmThresholdState {
  switch (action.type) {
    case AlarmThresholdActions.DEACTIVATE_ALARM_THRESHOLDS_SUCCESS:
      return {
        ...state,
        removed: true,
      };
    case AlarmThresholdActions.DEACTIVATE_ALARM_THRESHOLDS_FAILED:
      return {
        ...state,
        removed: false,
      };
    case AlarmThresholdActions.DEACTIVATE_ALARM_THRESHOLDS_RESET:
      return {
        ...state,
        removed: undefined,
      };
    case AlarmThresholdActions.ACTIVATE_ALARM_THRESHOLDS_SUCCESS:
      return {
        ...state,
        added: true,
        newThreshold: action.payload.threshold,
      };
    case AlarmThresholdActions.ACTIVATE_ALARM_THRESHOLDS_FAILED:
      return {
        ...state,
        added: false,
      };
    case AlarmThresholdActions.ACTIVATE_ALARM_THRESHOLDS_RESET:
      return {
        ...state,
        added: undefined,
      };
    case AlarmThresholdActions.CLOSE_MODAL:
      return {
        ...state,
        closed: true,
      };
    case AlarmThresholdActions.CLOSE_MODAL_RESET:
      return {
        ...state,
        closed: undefined,
      };
    case AlarmThresholdActions.UPDATE_THRESHOLDS_SUCCESS:
      return {
        ...state,
        newThreshold: action.payload.threshold,
        updated: true,
      };
    case AlarmThresholdActions.UPDATE_THRESHOLDS_FAILED:
      return {
        ...state,
        updated: false,
      };
    case AlarmThresholdActions.UPDATE_THRESHOLDS_RESET:
      return {
        ...state,
        updated: undefined,
      };
    default:
      return state;
  }
}

export const getThresholdDeactivated = (state: AlarmThresholdState) =>
  state.removed;
export const getThresholdActivated = (state: AlarmThresholdState) =>
  state.added;
export const getModalClosed = (state: AlarmThresholdState) => state.closed;
export const getThresholdsUpdated = (state: AlarmThresholdState) =>
  state.updated;
export const getNewThresholds = (state: AlarmThresholdState) =>
  state.newThreshold;
